module.exports = __webpack_public_path__ + "img/lumpkinhouse-h-474x356.265c5fee.jpg";